import { render, staticRenderFns } from "./OrganizationEditTabInformation.vue?vue&type=template&id=8bb639c2"
import script from "./OrganizationEditTabInformation.vue?vue&type=script&lang=js"
export * from "./OrganizationEditTabInformation.vue?vue&type=script&lang=js"
import style0 from "./OrganizationEditTabInformation.vue?vue&type=style&index=0&id=8bb639c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports